import React, { useState } from 'react';

const SectionHeader = ({ tabs, handleTabClick }) => {
  return (
    <div className='section-header'>
      {tabs.map((tab, index) => (
        <div  className="tab" key={index} onClick={() => handleTabClick(index)} >
          <p className={tab.isActive ? 'tab-active' : ''}>
            {tab.label}
          </p>
        </div>
      ))}
    </div>
  )
}

export default SectionHeader
